import { render } from "./UploadImage.vue?vue&type=template&id=2a21dabc"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ploi/mydiy.com.au-deploy/mydiy.com.au/03112026_120026/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__